const simpleMDEOptions = {
  autofocus: true,
  hideIcons: [
    'fullscreen',
    'side-by-side',
    'code',
    'horizontal-rule',
    'quote',
    'heading',
    'ordered-list'
  ],
  status: false,
  placeholder: 'Type your comment here.'
}

const italicsOnlyMDEOptions = {
  hideIcons: [
    'fullscreen',
    'side-by-side',
    'code',
    'horizontal-rule',
    'quote',
    'heading',
    'ordered-list',
    'bold',
    'unordered-list',
    'link',
    'image'
  ],
  status: false
}

const italicsAndBoldOnlyMDEOptions = {
  hideIcons: [
    'fullscreen',
    'side-by-side',
    'code',
    'horizontal-rule',
    'quote',
    'heading',
    'ordered-list',
    'unordered-list',
    'link',
    'image',
    'guide'
  ],
  status: false
}

const excludeImageMDEOptions = {
  hideIcons: [
    'fullscreen',
    'side-by-side',
    'code',
    'horizontal-rule',
    'image'
  ],
  status: false
}

export {
  simpleMDEOptions,
  italicsOnlyMDEOptions,
  italicsAndBoldOnlyMDEOptions,
  excludeImageMDEOptions
}



// WEBPACK FOOTER //
// ./src/utils/markdowneditor.js